import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../../../components/panel/panel';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import * as formik from 'formik';
import * as yup from 'yup';
import Swal from 'sweetalert2';
import axiosClient from '../../../../config/axios.js';
import TypeServiceFields from './formTypeServices/typeServiceFields'; 
import { findProductKeyByCoincidence, findUnitKeyByCoincidence } from "../../../../services/CatalogService";

function EditTypeService() {
    const [selectedProductKey, setSelectedProductKey] = useState(null);
    const [selectedUnitKey, setSelectedUnitKey] = useState(null);

    const { id } = useParams();
    const navigate = useNavigate();
    const { Formik } = formik;

    const [initialValues, setInitialValues] = useState({
        type_service_name: '',
    });

    useEffect(() => {
    axiosClient.get(`/typeServices/${id}`)
        .then(async response => {
        const { type_service_name, id_productKey, id_unitKey } = response.data;
        setInitialValues({ type_service_name });

        // Buscar el objeto completo por id_productKey
        if (id_productKey) {
            try {
            const [productKey] = await findProductKeyByCoincidence(id_productKey);
            setSelectedProductKey(productKey);
            } catch (error) {
            console.error('Error fetching product key:', error);
            }
        }

        // Buscar el objeto completo por id_unitKey
        if (id_unitKey) {
            try {
            const [unitKey] = await findUnitKeyByCoincidence(id_unitKey);
            setSelectedUnitKey(unitKey);
            } catch (error) {
            console.error('Error fetching unit key:', error);
            }
        }

        })
        .catch(error => {
        console.error('Error fetching typeService data:', error);
        });
    }, [id]);

    return (
        <div>
            <div className="d-flex align-items-center mb-3">
                <div>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Inicio</Link></li>
                        <li className="breadcrumb-item">Configuración</li>
                        <li className="breadcrumb-item"><Link to="/catalogs/type-services">Tipos de servicio</Link></li>
                        <li className="breadcrumb-item active">Edición de Tipo de servicio</li>
                    </ol>
                    <h1 className="page-header mb-0">Edición de Tipo de servicio</h1>
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-xl-12">
                    <Panel>
                        <PanelHeader>Edición de Tipo de servicio</PanelHeader>
                        <PanelBody>
                            <Formik
                                enableReinitialize
                                validationSchema={yup.object().shape({
                                    type_service_name: yup.string().required("Ingrese el nombre del Tipo de servicio"),
                                })}
                                onSubmit={(values, { setSubmitting }) => {
                                    const selected = selectedProductKey;
                                    const selectedUnit = selectedUnitKey;
                                    //console.log("selected ", selected);

                                    if (
                                      selected === null ||
                                      typeof selected !== "object" ||
                                      !selected.id
                                    ) {
                                      return Swal.fire(
                                        "Atención",
                                        "Selecciona una clave de producto válida",
                                        "warning"
                                      );
                                    }                
                                    
                                    if (selectedUnit === null || typeof selectedUnit !== "object" || !selectedUnit.id) {
                                        return Swal.fire(
                                        "Atención",
                                        "Selecciona una clave de unidad válida",
                                        "warning"
                                        );
                                    }
                                    const payload = {
                                        ...values,
                                        id_productKey: selected.idKey,
                                        id_unitKey: selectedUnit.idKey,
                                    };

                                    setSubmitting(false);                                    
                                    axiosClient.put(`/typeServices/${id}`, payload).then(response => {
                                        Swal.fire({
                                            title: 'Cambios guardados',
                                            text: 'El Tipo de servicio se ha actualizado exitosamente',
                                            icon: 'success',
                                            confirmButtonText: 'Cerrar'
                                        });
                                        navigate('/catalogs/type-services');
                                    }).catch(err => {
                                        let message = '';
                                        if (err.response?.data?.original?.code === '23505') {
                                            message = 'El nombre del Tipo de servicio ya existe. Ingresa uno diferente.';
                                        } else {
                                            message = err.response?.data?.message || 'Error al actualizar.';
                                        }
                                        Swal.fire({
                                            title: 'Ups!',
                                            text: message,
                                            icon: 'error',
                                            confirmButtonText: 'Cerrar'
                                        });
                                    });
                                }}
                                initialValues={initialValues}
                            >
                                {({ handleSubmit, handleChange, values, errors }) => (
                                    <Form noValidate onSubmit={handleSubmit}>
                                        <TypeServiceFields
                                        values={values}
                                        handleChange={handleChange}
                                        errors={errors}
                                        selectedProductKey={selectedProductKey}
                                        setSelectedProductKey={setSelectedProductKey}
                                        selectedUnitKey={selectedUnitKey}
                                        setSelectedUnitKey={setSelectedUnitKey}
                                        />

                                        <Row className="mb-3">
                                            <Col md="12">
                                                <Button type="submit">Guardar cambios</Button>{' '}
                                                <Link to="/catalogs/type-services" className="btn btn-info">Cancelar</Link>
                                            </Col>
                                        </Row>
                                    </Form>
                                )}
                            </Formik>
                        </PanelBody>
                    </Panel>
                </div>
            </div>
        </div>
    );
}

export default EditTypeService;
